import script from "./PersistentToggle.vue?vue&type=script&lang=js"
export * from "./PersistentToggle.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__